// mv h1切り替え
document.addEventListener("DOMContentLoaded", () => {
	const BREAKPOINT = 768;
	const h1Pc = document.querySelector(".mv__title.u-show--pc");
	const h1Sp = document.querySelector(".mv__title.u-show--tab-sp");

	function toggleAria() {
		if (window.innerWidth > BREAKPOINT) {
			h1Pc?.setAttribute("aria-hidden", "false");
			h1Sp?.setAttribute("aria-hidden", "true");
		} else {
			h1Pc?.setAttribute("aria-hidden", "true");
			h1Sp?.setAttribute("aria-hidden", "false");
		}
	}

	toggleAria();
	window.addEventListener("resize", toggleAria);
});

// パートナー様の声 スライダー
jQuery(function ($) {
	$(".voice__slider").slick({
		autoplay: true,
		dots: true,
		infinite: true,
		prevArrow: '<button type="button" class="slick-prev"><span></span></button>',
		nextArrow: '<button type="button" class="slick-next"><span></span></button>',
		responsive: [
			{
				breakpoint: 769,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: "8.5%",
				},
			},
		],
	});
});

// 最新情報 タブ
document.addEventListener("DOMContentLoaded", () => {
	const tablists = document.querySelectorAll('.information__tabs[role="tablist"]');
	if (!tablists.length) return;

	tablists.forEach((tablist) => {
		const tabs = Array.from(tablist.querySelectorAll('.information__tab[role="tab"]'));
		const panels = tabs.map((t) => document.getElementById(t.getAttribute("aria-controls"))).filter(Boolean);

		// 初期化
		let activeIndex = Math.max(
			0,
			tabs.findIndex((t) => t.getAttribute("aria-selected") === "true")
		);
		tabs.forEach((tab, i) => setTabState(tab, panels[i], i === activeIndex));

		// クリック
		tabs.forEach((tab, i) => {
			tab.addEventListener("click", () => activate(i, { focus: true }));
		});

		// キーボード操作（← → Home End）
		tablist.addEventListener("keydown", (e) => {
			const key = e.key;
			const last = tabs.length - 1;

			if (key === "ArrowRight" || key === "ArrowLeft") {
				e.preventDefault();
				const dir = key === "ArrowRight" ? 1 : -1;
				activeIndex = (activeIndex + dir + tabs.length) % tabs.length;
				tabs[activeIndex].focus();
				activate(activeIndex, { focus: false });
			} else if (key === "Home") {
				e.preventDefault();
				activeIndex = 0;
				tabs[0].focus();
				activate(0, { focus: false });
			} else if (key === "End") {
				e.preventDefault();
				activeIndex = last;
				tabs[last].focus();
				activate(last, { focus: false });
			}
		});

		function activate(index, { focus }) {
			tabs.forEach((tab, i) => setTabState(tab, panels[i], i === index));
			activeIndex = index;
			if (focus) tabs[index].focus();
		}

		function setTabState(tab, panel, selected) {
			tab.setAttribute("aria-selected", String(selected));
			tab.tabIndex = selected ? 0 : -1;
			tab.classList.toggle("is-active", selected);

			if (panel) {
				panel.classList.toggle("is-active", selected);
				panel.toggleAttribute("hidden", !selected); // ← hidden属性だけで制御
				panel.setAttribute("aria-labelledby", tab.id);
			}
		}
	});
});
